import { ShoppingCart } from "lucide-react"
import { useState } from "react"

import { Button } from "@/components/ui/button"
import type { CustomerOngoingOrderByStatusLoader } from "@/data/customerDataLoader"
import { useCart } from "@/hooks/useCart"
import { cn } from "@/lib/utils"

import { CustomerCart } from "./customer/CustomerCart"
import { ItemQuantityBadge } from "./customer/ItemQuantityBadge"
import ModalComp from "./ModalComp"

export default function PopoverCart({ ongoingOrder }: { ongoingOrder: CustomerOngoingOrderByStatusLoader | null }) {
  const [openCart, setOpenCart] = useState(false)
  const { getTotalQuantity } = useCart()
  const totalQuantity = getTotalQuantity()

  return (
    <ModalComp
      className=""
      isOpen={openCart}
      onOpenChange={setOpenCart}
      trigger={
        <Button
          variant="ghost"
          className={cn("relative size-4 rounded-full py-4", openCart && "cursor-default")}
          onClick={() => setOpenCart(!openCart)}
        >
          <ShoppingCart className="size-4" />
          <span className="sr-only">Cart</span>
          {(totalQuantity > 0 || ongoingOrder) && (
            <ItemQuantityBadge quantity={totalQuantity} pulsating={!!ongoingOrder} />
          )}
        </Button>
      }
    >
      <CustomerCart
        ongoingOrder={ongoingOrder as CustomerOngoingOrderByStatusLoader}
        closeCart={() => setOpenCart(false)}
      />
    </ModalComp>
  )
}
